import client from "../api-client";
import toQueryString from "../toQueryString";

export const get = (rid) => {
  let params = toQueryString({
    rid: rid,
  });
  return client(`admin_roles.php?${params}`);
};

export const getProfile = () => {
  return client(`admin_profile.php`);
};

export const getPermissions = () => {
  return client(`admin_permissions.php`);
};

export const savePermissions = (rid, role_name, permissions) => {
  let method = "POST";

  return client(`admin_roles.php`, {
    method: method,
    body: {
      rid: rid,
      role_name: role_name,
      permissions: permissions,
    },
  });
};
